import { gql } from '@apollo/client';
import { Products } from '../../fragments/product/products.fragments';

export const QUERY_SHOP = gql`
  query GetPublicShop($id: ID!, $classeId: ID!) {
    shop(id: $id, classeId: $classeId, sort: "name:asc") {
      produits {
        id
        attributes {
          ...MainProducts
        }
      }
    }
  }
  ${Products.fragments.main}
`;
